import { IBaseService, IModelEntity } from '@pit/core';
import { IEntityDataService } from './entity.data.service.interface';

export interface IEntityDataServiceAccessorService extends IBaseService {

    getEntityDataService<T extends IModelEntity>(serviceName: string): IEntityDataService<T>;
    registerEntityDataService<T extends IModelEntity>(serviceName: string, entityDataService: IEntityDataService<T>): void;

}
